export default {
    add_stage: "Додати етап",
    additional: "Додатковий",
    alternative: "Альтернативний",
    amount_completed: "Сума виконана",
    apply_plan_treatment: "Застосувати план лікування",
    apply_to_which_teeth: "До яких зубів застосувати",
    apply_treatment_stage_template: "Застосувати шаблон етапу лікування",
    are_you_sure_you_want_to_cancel_plan: "Ви впевнені, що хочете скасувати план лікування?",
    by_stages: "По етапах",
    calls_planning: "Планування дзвінків",
    cancel_plan_treatment: "Скасувати план лікування",
    changes_in_current_stage_were_not_saved: "Зміни на поточному етапі не збережені",
    choose_criterias_for_fill: "Виберіть потрібні критерії для заповнення",
    collapse: "Згорнути",
    comments: "Коментарі",
    completed_sum: "Виконана сума",
    complex_doctor: "Лікар комплексу",
    'DD.MM.YYYY': "ДД.ММ.РРРР",
    deadline2: "Крайній термін",
    delete_stage: "Видалити етап",
    document_header: "Шапка в плані лікування",
    editing_is_blocked_now_user_is_working: "Редагування тимчасово недоступне: зараз працює {user}",
    expand: "Розгорнути",
    grouped: "Згрупований",
    grouped_by_services: "Згрупований по послугах",
    grouped_by_teeth: "Згрупований по зубах",
    hide_tooth_formula: "Приховати зубну формулу",
    kits_and_materials: "Комплекти та матеріали",
    last_update: "Остання зміна",
    left: "Залишилось",
    level_description: "Опис етапу",
    main_complaints: "Основні скарги",
    not_signed: "Не підписаний",
    notification_date: "Дата повідомлення",
    plan: "План",
    plan_status: "Статус плану",
    plan_treatment_application: "Застосування плану лікування",
    plan_treatment_status: "Статус плану лікування",
    plan_type: "Тип плану",
    planned_sum: "Запланована сума",
    previous_visits: "Попередні візити",
    quantity: "Кількість",
    recommended: "Рекомендований",
    reset_all: "Скинути все",
    route_list: "Маршрутний лист",
    save_as_plan_stage_template: "Зберегти як шаблон етапу лікування",
    select_a_doctor_2: "Виберіть лікаря",
    select_all: "Вибрати все",
    select_field: "Виберіть напрямок",
    select_number: "Виберіть номер",
    select_plan: "Виберіть план",
    select_type: "Виберіть тип",
    services_selected: "Послуг вибрано",
    show_tooth_formula: "Показати зубну формулу",
    sign_without_upload: "Підписати без завантаження",
    signed_at: "Підписаний",
    stage_deletion_confirm_text: "Етап буде видалено без можливості відновлення.",
    stage_doctor: "Лікар етапу",
    stage_title: "Назва етапу",
    stages_discount: "Знижка у етапах",
    total_sum: "Всього сума",
    treatment_plan_amount: "Сума плану лікування",
    treatment_plan_doctor: "Лікар плану лікування",
    treatment_template_application: "Застосування шаблону лікування",
    which_fields_to_fill: "Які поля заповнити",
    write_patient_complaints: "Напишіть скарги пацієнта",
    write_stage_description: "Напишіть опис етапу"
}
